import { render, staticRenderFns } from "./PnetMessageListView.vue?vue&type=template&id=3250e89a"
import script from "./PnetMessageListView.vue?vue&type=script&lang=js"
export * from "./PnetMessageListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports